import PropTypes from 'prop-types'
import { Box } from 'theme-ui'
import { Link } from 'react-router'
import Logomark from './framework/Logomark'
import strings, { currentLang, setLanguage } from '../strings/strings'
// import DonationBanner from './conversation-admin/DonationBanner'

const LANGS = [
  { code: 'uk', label: 'UA' },
  { code: 'en', label: 'EN' }
]

const InteriorHeader = ({ children }) => {
  return (
    <Box sx={{ width: '100%', overflowX: 'hidden' }}>
      <Box
        sx={{
          width: '100%',
          backgroundColor: 'primaryDark',
          color: 'background',
          zIndex: 1000,
          py: [2, 2, 3],
          px: [2, 3, 4],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: [1, 2, 3],
          minHeight: 0
        }}>
        <Link
          sx={{
            variant: 'links.header',
            display: 'flex',
            alignItems: 'center',
            gap: [1, 2, 2],
            flexShrink: 0
          }}
          to="/">
          <Logomark style={{ position: 'relative', top: 2 }} fill={'white'} />
          <Box sx={{ fontSize: [2, 2, 2], whiteSpace: 'nowrap' }}>Polis</Box>
        </Link>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: [2, 3, 3], flexShrink: 0 }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {LANGS.map(({ code, label }) => (
              <Box
                key={code}
                as="button"
                onClick={() => setLanguage(code)}
                sx={{
                  background: 'none',
                  border: 'none',
                  color: currentLang === code ? 'white' : 'rgba(255,255,255,0.5)',
                  fontWeight: currentLang === code ? 'bold' : 'normal',
                  cursor: 'pointer',
                  fontSize: [0, 1, 1],
                  px: 1,
                  py: 0,
                  textDecoration: currentLang === code ? 'underline' : 'none'
                }}>
                {label}
              </Box>
            ))}
          </Box>
          <Link
            id="signoutLink"
            sx={{
              variant: 'links.header',
              fontSize: [1, 2, 2],
              whiteSpace: 'nowrap'
            }}
            to="/signout">
            {strings('sign out')}
          </Link>
        </Box>
      </Box>
      {/* <DonationBanner /> */}
      <Box sx={{ width: '100%', overflowX: 'auto' }}>{children}</Box>
    </Box>
  )
}

InteriorHeader.propTypes = {
  children: PropTypes.node
}

export default InteriorHeader
